import { useState, useEffect } from 'react';
import API, { ROLES } from '../utils/api';

const EMPTY = { name: '', username: '', password: '', role: 'sales_employee', active: 1 };

export default function Users() {
  const [users, setUsers] = useState([]);
  const [modal, setModal] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(EMPTY);
  const [error, setError] = useState('');

  const load = () => API.get('/users').then(r => setUsers(r.data));
  useEffect(() => { load(); }, []);

  const openNew = () => { setEditing(null); setForm(EMPTY); setError(''); setModal(true); };
  const openEdit = (u) => { setEditing(u.id); setForm({ ...u, password: '' }); setError(''); setModal(true); };

  const save = async () => {
    if (!form.name || !form.username) return setError('الاسم واسم المستخدم مطلوبان');
    if (!editing && !form.password) return setError('كلمة المرور مطلوبة للمستخدم الجديد');
    try {
      if (editing) await API.put(`/users/${editing}`, form);
      else await API.post('/users', form);
      setModal(false); load();
    } catch (e) { setError(e.response?.data?.error || 'حدث خطأ'); }
  };

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">👤 إدارة المستخدمين</h1>
        <button className="btn btn-primary" onClick={openNew}>+ مستخدم جديد</button>
      </div>

      {modal && (
        <div className="modal-overlay" onClick={() => setModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <span className="modal-title">{editing ? 'تعديل مستخدم' : 'مستخدم جديد'}</span>
              <button className="modal-close" onClick={() => setModal(false)}>✕</button>
            </div>
            <div className="modal-body">
              {error && <div className="alert alert-error">{error}</div>}
              <div className="form-grid">
                <div className="form-group"><label>الاسم الكامل <span className="required">*</span></label><input value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} /></div>
                <div className="form-group"><label>اسم المستخدم <span className="required">*</span></label><input value={form.username} onChange={e => setForm({ ...form, username: e.target.value })} autoComplete="off" /></div>
                <div className="form-group"><label>{editing ? 'كلمة المرور الجديدة (اتركها فارغة للإبقاء)' : 'كلمة المرور *'}</label><input type="password" value={form.password || ''} onChange={e => setForm({ ...form, password: e.target.value })} autoComplete="new-password" /></div>
                <div className="form-group"><label>الدور</label>
                  <select value={form.role} onChange={e => setForm({ ...form, role: e.target.value })}>
                    {Object.entries(ROLES).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
                  </select>
                </div>
                {editing && (
                  <div className="form-group">
                    <label>الحالة</label>
                    <select value={form.active} onChange={e => setForm({ ...form, active: +e.target.value })}>
                      <option value={1}>نشط</option>
                      <option value={0}>معطل</option>
                    </select>
                  </div>
                )}
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-primary" onClick={save}>💾 حفظ</button>
              <button className="btn btn-secondary" onClick={() => setModal(false)}>إلغاء</button>
            </div>
          </div>
        </div>
      )}

      <div className="table-container">
        <div className="table-scroll">
          <table>
            <thead><tr><th>الاسم</th><th>اسم المستخدم</th><th>الدور</th><th>الحالة</th><th>تاريخ الإنشاء</th><th>تعديل</th></tr></thead>
            <tbody>
              {users.map(u => (
                <tr key={u.id}>
                  <td className="font-bold">{u.name}</td>
                  <td className="text-muted">{u.username}</td>
                  <td><span className="badge badge-primary">{ROLES[u.role]}</span></td>
                  <td><span className={`badge ${u.active ? 'badge-success' : 'badge-danger'}`}>{u.active ? 'نشط' : 'معطل'}</span></td>
                  <td className="text-muted">{u.created_at?.split('T')[0]}</td>
                  <td><button className="btn btn-sm btn-secondary" onClick={() => openEdit(u)}>تعديل</button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
